// TODO: lots of duplicate type definitions
// but already super burned out, need to de-duplication
import { ApiIdContext, RecoilStateContext } from './Context.js';
import { garbageCollectionKey } from './GarbageCollector.js';
import { useContext } from 'react';
import { atomFamily, constSelector, isRecoilValue } from 'recoil';
export const queryAtomFamily = (options) => {
    const _state = atomFamily({
        key: options.key,
        effects: ([apiId, typeName, moduleName, sectionName, params]) => [
            ({ setSelf, getPromise }) => {
                const maybeApi = options.getApi(apiId);
                const apiPromise = (async () => {
                    if (isRecoilValue(maybeApi)) {
                        return await getPromise(maybeApi);
                    }
                    if ('then' in maybeApi) {
                        return await maybeApi;
                    }
                    return maybeApi;
                })();
                let initialResolve = (_value) => { };
                let initialReject = (_reason) => { };
                setSelf(new Promise((resolve, reject) => {
                    initialResolve = resolve;
                    initialReject = reject;
                }));
                const unsubscribePromise = apiPromise.then(async (api) => {
                    const [section, multi] = sectionName.split('.');
                    const func = 
                    // @ts-expect-error
                    multi === undefined ? api[typeName][moduleName][section] : api[typeName][moduleName][section][multi];
                    const parsedParams = multi === undefined ? params : [params];
                    const unsubscribePromise = func(...parsedParams, (result) => {
                        initialResolve(result);
                        setSelf(result);
                    }).catch((error) => {
                        initialReject(error);
                    });
                    return await unsubscribePromise;
                });
                return () => {
                    void unsubscribePromise.then(unsubscribe => unsubscribe());
                };
            },
        ],
        dangerouslyAllowMutability: true,
    });
    const queryState = (apiId, moduleName, sectionName, params) => _state([
        apiId,
        'query',
        // @ts-expect-error
        moduleName,
        // @ts-expect-error
        sectionName,
        params,
    ]);
    const deriveState = (apiId, moduleName, sectionName, params) => _state([
        apiId,
        'derive',
        moduleName,
        // @ts-expect-error
        sectionName,
        params,
    ]);
    return {
        queryState: Object.assign(queryState, { [garbageCollectionKey]: options.key }),
        deriveState: Object.assign(deriveState, { [garbageCollectionKey]: options.key }),
    };
};
export const useQueryState = (moduleName, sectionName, params, options = { enabled: true }) => {
    if (!options.enabled) {
        return constSelector(undefined);
    }
    return useContext(RecoilStateContext).queryState(useContext(ApiIdContext), moduleName, sectionName, 
    // @ts-expect-error
    params);
};
export const useDeriveState = (moduleName, sectionName, params, options = { enabled: true }) => {
    if (!options.enabled) {
        return constSelector(undefined);
    }
    // @ts-expect-error
    return useContext(RecoilStateContext).deriveState(useContext(ApiIdContext), moduleName, sectionName, 
    // @ts-expect-error
    params);
};
//# sourceMappingURL=query.js.map